/**
 * /dashboard/leave/new — Request-leave form route (SOP §1.2;
 * Phase 3b — 2026-06-01).
 *
 * Pattern B per docs/19-FRONTEND-UI-PATTERNS.md — a dedicated route for
 * a form with 7+ inputs + date pickers + live working-day estimate +
 * balance impact. Do NOT modal-ize.
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/leave/new/page.tsx. Swaps:
 *   - "use client" dropped
 *   - next/link → @tanstack/react-router Link
 * The form submits via LeaveRequestForm; on success it navigates to
 * `/dashboard/leave/$id` (the detail route which lands as part of this
 * same Phase 3b batch).
 */

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { TimeAndLeaveShell } from "@/components/shared/time-and-leave-shell";
import { LeaveFeatureGate } from "@/components/leave/leave-feature-gate";
import { LeaveRequestForm } from "@/components/leave/leave-request-form";
import { Card, CardContent } from "@/components/ui/card";
import { parseDayParam } from "@/lib/attendance-register";

// ?date=YYYY-MM-DD starts the form on that day (My Time's missing-day card).
const searchSchema = z.object({
  date: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/_authgated/app/$tenantSlug/leave/new")({
  validateSearch: searchSchema,
  component: NewLeaveRequestRoute,
});

function NewLeaveRequestRoute() {
  const initialDate = parseDayParam(Route.useSearch().date) ?? undefined;
  // Top-of-page Back button removed per Audit 4 Quick-Win #4 — the
  // bottom Cancel button (right-aligned per Quick-Win #3) does the
  // same job inside the action row, where the user already is.
  return (
    <TimeAndLeaveShell
      title="Request Leave"
      description="Submit a leave request for approval."
    >
      <LeaveFeatureGate>
        <Card className="max-w-2xl">
          <CardContent className="pt-6">
            <LeaveRequestForm initialDate={initialDate} />
          </CardContent>
        </Card>
      </LeaveFeatureGate>
    </TimeAndLeaveShell>
  );
}
